const API_BASE_URL = (typeof window !== 'undefined' && (window as any).ENV?.EXPO_PUBLIC_GRAIN_API_URL) || '';

export async function fetchGrainStocks(userId: string, token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/grain/${userId}`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch grain stocks for user ${userId}`);
  }
  const result = await response.json();
  return result.data;
}

export async function updateGrainStocks(
  userId: string,
  grains: { cereal: string; tonnage: number }[],
  changeReason: string,
  token: string
): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/grain/${userId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({
      change_reason: changeReason,
      grains: grains
    })
  });
  if (!response.ok) {
    throw new Error(`Failed to update grain stocks for user ${userId}`);
  }
  return response.json();
}

export async function initGrainStocks(
  userId: string,
  grains: { cereal: string; tonnage: number }[],
  token: string
): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/grain`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: userId,
      grains: grains
    })
  });
  if (!response.ok) {
    throw new Error(`Failed to initialize grain stocks for user ${userId}`);
  }
  return response.json();
}

export async function seedGrainsDatabase(token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/grain/seed`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to seed grains database");
  }

  return response.json();
}

export async function fetchMyGrainStocks(token: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/grain/me`, {
    headers: {
      "Authorization": `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to fetch my grain stocks");
  }

  const result = await response.json();
  return result.data;
}
